export const currencies = [
    { code: 'EUR', label: 'EUR' },
    { code: 'USD', label: 'USD' },
];